import $ from 'jquery';
import Animation from '../../modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#info',
			dom: {
				form: '#infoForm',
				lastname: '#infoLastname',
				firstname: '#infoFirstname',
				secondname: '#infoSecondname',
				city: '#infoCity',
				story: '#infoStory',
				conditions: '#infoConditions'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		this.breakWords = [
			'1',
			'2'
		];
		return this;
	}

	get() {
		const {form, lastname, firstname, secondname,
				city, story, conditions} = this.options.dom;

		this.$form = this.$el.find(form);
		this.$lastname = this.$el.find(lastname);
		this.$firstname = this.$el.find(firstname);
		this.$secondname = this.$el.find(secondname);
		this.$city = this.$el.find(city);
		this.$story = this.$el.find(story);
		this.$conditions = this.$el.find(conditions);

		return this;
	}

	ckeckBreak(val) {
		const value = val.toLowerCase();
		let error = false;
		$.each(this.breakWords, function (key, w) {
			const word = w.toLowerCase();
			if (value.indexOf(word) >= 0) {
				error = true;
			}
		});
		return error;
	}

	onSubmit = event => {
		event.preventDefault();
		let error = false;


		if (this.$lastname.val().trim() === '' || this.ckeckBreak(this.$lastname.val().trim())) {
			error = true;
			this.$lastname.trigger('error');
			$(() => new Animation({el: this.$lastname.parent()}).play('shake'));
		}
		if (this.$firstname.val().trim() === '' || this.ckeckBreak(this.$firstname.val().trim())) {
			error = true;
			this.$firstname.trigger('error');
			$(() => new Animation({el: this.$firstname.parent()}).play('shake'));
		}
		if (this.$secondname.val().trim() === '' || this.ckeckBreak(this.$secondname.val().trim())) {
			error = true;
			this.$secondname.trigger('error');
			$(() => new Animation({el: this.$secondname.parent()}).play('shake'));
		}
		if (this.$city.val().trim() === '' || this.ckeckBreak(this.$city.val().trim())) {
			error = true;
			this.$city.trigger('error');
			$(() => new Animation({el: this.$city.parent()}).play('shake'));
		}
		if (this.$story.val().trim() === '') {
			error = true;
			this.$story.trigger('error');
			$(() => new Animation({el: this.$story.parent()}).play('shake'));
		}
		if (!this.$conditions.is(':checked')) {
			error = true;
			$(() => new Animation({el: this.$conditions.parent()}).play('shake'));
		}

		if (!error) {
			this.$window.trigger('navigation.setup', 'auth');
		}
	}

	onClear() {
		this.$lastname.val('').attr('value', '').trigger('change focus blur');
		this.$firstname.val('').attr('value', '').trigger('change focus blur');
		this.$secondname.val('').attr('value', '').trigger('change focus blur');
		this.$city.val('').attr('value', '').trigger('change focus blur');
		this.$story.val('').html('').trigger('change focus blur');
		this.$conditions.prop('checked', true);
	}

	onSend() {
		const self = this;
		const formdata = self.$form.serializeArray();
		const data = {};
		$(formdata).each(function (index, obj){
			data[obj.name] = obj.value;
		});
		$.ajax({
			url: self.$form.attr('action'),
			type: self.$form.attr('method'),
			data: self.$form.serialize(),
			dataType: 'json',
			success: function (json) {
				if (json && json.error) {
					if (json.message) {
						alert(json.message);
					}
				}

				if (json && json.requestId) {
					self.$window
						.trigger('requestId.set', [json.requestId, data, json.data, json])
						.trigger('screen.final');
				}
			}
		});
	}

	onField(event) {
		const $target = $(event.currentTarget);
		let val = $target[0].value;
		val = val.replace(/[^(a-zа-яё-\s)]/gi, '');
		val = val.charAt(0).toUpperCase() + val.slice(1);
		if (val.length > 30) {
			val = val.substr(0, 30);
		}
		if (val !== $target[0].value) {
			$target[0].value = val;
		}
	}
	onFieldStory(event) {
		const $target = $(event.currentTarget);
		let val = $target[0].value;
		if (val.length > 2000) {
			val = val.substr(0, 2000);
		}
		if (val !== $target[0].value) {
			$target[0].value = val;
		}
	}

	init() {
		this.$form.on('submit', this.onSubmit.bind(this));
		this.$window.on('info.clear', this.onClear.bind(this));
		this.$window.on('info.send', this.onSend.bind(this));

		this.$lastname
			.add(this.$firstname)
			.add(this.$secondname)
			.add(this.$city)
			.on('input change paste', this.onField.bind(this));

		this.$story.on('input change paste', this.onFieldStory.bind(this));
	}

	render() {
		if (this.$el.length) {
			this
				.get()
				.init();

			// const data = {};
			// data.department = 'Там служил';
			// data['last-name'] = 'Константино';
			// data.name = 'Анатолий';
			// data['second-name'] = 'Самсонов';
			// data.rank = 'Младший сержант';

			// const self = this;
			// setTimeout(function () {
			// 	self.$window
			// 		.trigger('requestId.set', [123, data, {
			// 			out: '9 мая 12:20',
			// 			num: 'S71155',
			// 			direction: {
			// 				from: {
			// 					name: 'Симферополь',
			// 					code: 'SIP'
			// 				},
			// 				to: {
			// 					name: 'Москва',
			// 					code: 'MOW'
			// 				}
			// 			}
			// 		}, {shareUrl: '#'}])
			// 		.trigger('screen.final');
			// }, 1100);
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/info/info.js